// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"2403aab9","259":"97998725","549":"4ff53340","994":"cdc41026"}[chunkId] + ".chunk.css";
};